import useStore from "./useStore";

export default function useActionCreators(...creators) {
  const [, dispatch] = useStore();
  return creators.map(creator => (...param) => dispatch(creator(...param)));
}
